import { createAction } from '@reduxjs/toolkit';
import { normalizeError } from 'core/common/errors';
import { AppThunk } from 'core/common/store';
import { UpdateUserPayload } from 'core/user/entities';

export const updateUserPending = createAction('user/UPDATE_USER/pending');

export const updateUserSucceed = createAction('user/UPDATE_USER/succeed');

export const updateUser =
  (data: UpdateUserPayload): AppThunk =>
  async (dispatch, _, context) => {
    const { userService, loggingService } = context;
    dispatch(updateUserPending());

    try {
      await userService.update(data);
      dispatch(updateUserSucceed());
    } catch (e) {
      const err = normalizeError(e);
      loggingService.error(err);
      return null;
    }
  };
